<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import AdminNavbar from 'components/Navbars/AdminNavbar.svelte';
  import FooterAdmin from 'components/Footers/FooterAdmin.svelte';
  import Picking from 'views/admin/Picking.svelte';
  import { getStoredUserRole, isPickerRole, getHomeRouteForRole } from '../lib/roles.js';

  export let location;

  onMount(() => {
    const role = getStoredUserRole();
    if (role && !isPickerRole(role)) {
      navigate(getHomeRouteForRole(role));
    }
  });
</script>

<div class="relative bg-blueGray-100 min-h-screen">
  <AdminNavbar />
  <div class="px-4 md:px-10 mx-auto w-full pt-24">
    <Picking />
    <FooterAdmin />
  </div>
</div>
